module.exports = __webpack_public_path__ + "static/media/alpha_5.b693991b.png";